import { Box, Grid, Paper, Typography } from '@mui/material';
import { formatMoney } from './AnalyticsKpiCard';
import { analyticsColors, analyticsPanelSx } from './analyticsStyles';

interface CakeItem {
  rank: number;
  id: string;
  name: string;
  quantitySold: number;
  revenue: number;
}

interface Props {
  cakes?: CakeItem[];
}

export const TopSellingCakesSection = ({ cakes }: Props) => {
  return (
    <Paper elevation={0} sx={{ ...analyticsPanelSx, mt: 3 }}>
      <Box sx={{ mb: 2.5 }}>
        <Typography
          sx={{
            fontSize: '1.125rem',
            fontWeight: 600,
            color: analyticsColors.title,
            lineHeight: 1.3,
          }}
        >
          Top Selling Cakes
        </Typography>
        <Typography
          sx={{
            fontSize: '0.8125rem',
            color: analyticsColors.subtitle,
            mt: 0.5,
          }}
        >
          Best performers in the selected period
        </Typography>
      </Box>

      <Grid container spacing={1.5}>
        {cakes?.map((cake) => (
          <Grid item xs={12} sm={6} md={4} key={cake.id}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                px: 1.5,
                py: 1.25,
                bgcolor: analyticsColors.cardBg,
                border: `1px solid ${analyticsColors.cardBorder}`,
                borderRadius: '10px',
                minHeight: 56,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    minWidth: 28,
                    borderRadius: '50%',
                    bgcolor: analyticsColors.rankBg,
                    color: analyticsColors.rankText,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                  }}
                >
                  {cake.rank}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      color: analyticsColors.title,
                      lineHeight: 1.3,
                    }}
                  >
                    {cake.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '0.75rem',
                      color: analyticsColors.subtitle,
                      mt: 0.125,
                    }}
                  >
                    {cake.quantitySold} orders
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: analyticsColors.title,
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
              >
                {formatMoney(cake.revenue)}
              </Typography>
            </Box>
          </Grid>
        ))}
        {!cakes?.length && (
          <Grid item xs={12}>
            <Typography
              align='center'
              sx={{ color: analyticsColors.subtitle, py: 3 }}
            >
              No record found
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
